import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './ServicePage.module.scss';

type ServicePageProps = {
  coverImageLink: string;
  coverImageAlt: string;
  coverImageTitle: string;

  pageTitle: string;
  pageDescription: string[];

  buttonTitle: string;

  galleryTitle: string;

  galleryImage1Link: string;
  galleryImage1Title: string;
  galleryImage1Description: string;

  galleryImage2Link: string;
  galleryImage2Title: string;
  galleryImage2Description: string;

  galleryImage3Link: string;
  galleryImage3Title: string;
  galleryImage3Description: string;

  blockTitle: string;
  blockDescription: string;
  blockImageLink: string;

  faqHeader?: string;
  faqItems?: Array<{ title: string; details: string }>;
  serviceList?: Array<{ name: string }>;
  mainPageUrl?: string;
};
export const ServicePage = (props: ServicePageProps) => {
  const {
    coverImageLink,
    coverImageAlt,
    coverImageTitle,
    pageTitle,
    pageDescription,
    buttonTitle,
    galleryTitle,
    galleryImage1Link,
    galleryImage1Title,
    galleryImage1Description,
    galleryImage2Link,
    galleryImage2Title,
    galleryImage2Description,
    galleryImage3Link,
    galleryImage3Title,
    galleryImage3Description,
    blockTitle,
    blockDescription,
    blockImageLink,
    faqHeader,
    faqItems = defaultFaqItems,
    serviceList = defaultServiceList,
    mainPageUrl,
  } = props;
  console.log(coverImageLink);
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink={coverImageLink}
        imageAlt={coverImageAlt}
        title={coverImageTitle}
      />

      <section className={styles.services}>
        <div className={styles.root}>
          <div className={styles.services_card_block}>
            <div className={styles.container}>
              <div className={styles.inner_section}>
                <TitleAndDescComponent
                  styles={styles}
                  title={pageTitle}
                  descriptions={pageDescription}
                />

                <CTAButton title={buttonTitle} serviceName={buttonTitle} />

                <div
                  className={cx(
                    styles.wrap_section,
                    styles.service_content_container,
                  )}>
                  <TitleAndDescComponent
                    styles={styles}
                    subTitle={galleryTitle}
                  />
                  <div className={styles.service_items}>
                    <ServiceItem
                      styles={styles}
                      imgSrc={galleryImage1Link}
                      imgAlt={galleryImage1Title}
                      title={galleryImage1Title}
                      description={galleryImage1Description}
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc={galleryImage2Link}
                      imgAlt={galleryImage2Title}
                      title={galleryImage2Title}
                      description={galleryImage2Description}
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc={galleryImage3Link}
                      imgAlt={galleryImage3Title}
                      title={galleryImage3Title}
                      imgObjectFit="cover"
                      description={galleryImage3Description}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.root}>
        <EmergencyComponent
          title={blockTitle}
          imageSrc={blockImageLink}
          imageAlt={blockTitle}
          styles={styles}
          para1={blockDescription}
        />
        <ListOfServices styles={styles} serrviceList={serviceList} />
        <AreasWeCover styles={styles} />
        <PostCodes styles={styles} mainPageUrl={mainPageUrl} />
        <FAQsView title={faqHeader || "FAQs"} faqItems={faqItems} />
      </div>
    </>
  );
};

const defaultServiceList = [
  { name: 'Boiler fault finding' },
  { name: 'Boiler repairs' },
  { name: 'Boiler installation' },
  { name: 'Gas appliance repairs' },
  { name: 'Gas appliance installation' },
  { name: 'Gas safety certificates (GSC)' },
  { name: 'Boiler servicing' },
  { name: 'Gas leaks' },
  { name: 'Central heating controls' },
  { name: 'Thermostats' },
  { name: 'Central heating pumps' },
  { name: 'Central heating repairs' },
  { name: 'Power flushes' },
  { name: 'Radiator leaks' },
  { name: 'Radiator valves' },
  { name: 'Emergency gas engineer' },
];

const defaultFaqItems = [
  {
    title: 'How often should I service my boiler?',
    details: `It's recommended to service your boiler once a year to ensure it runs safely and efficiently. Annual servicing helps prevent unexpected issues and prolongs the life of your boiler.`,
  },
  {
    title: 'What are the signs my boiler needs a repair?',
    details:
      'Strange noises, low pressure, inconsistent heating, a yellow flame instead of blue, or frequent error codes can all indicate that your boiler needs a repair. If you notice any of these signs, contact our qualified heating engineer.',
  },
  {
    title: 'What type of boiler is best for my home?',
    details: `The ideal boiler depends on the size of your home, your water usage, and heating needs. Combi boilers are compact and great for smaller homes, while system or regular boilers are better suited for larger properties. Our heating engineers can help you decide which option is best for you.`,
  },

  {
    title: "How can I improve my boiler's efficiency?",
    details: `To improve boiler efficiency, consider regular servicing, bleeding radiators, installing a thermostat, and using a timer. If your boiler is older, upgrading to a more energy-efficient model might be a smart move.`,
  },

  {
    title: 'What should I do if my boiler loses pressure?',
    details: `If your boiler's pressure gauge drops below 1 bar, you may need to re-pressurize it. Follow the manufacturer’s instructions or get in touch with our heating engineer. Persistent pressure loss may indicate a leak or another issue that requires professional attention.`,
  },
];
